export { useToggleSlideFavorite } from "#use-toggle-slide-favorite";
